import React, { useState, useEffect, useRef } from 'react'
import { GooglePlacesAutocompleteExtended } from 'srcReact/components'
import config from 'config'
import { geocodeByPlaceId, formatGoogleResult } from 'srcReact/services/googleService'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'

export default function LocationTextBox({
  placeholder,
  ariaLabel,
  value,
  locationContainerCSS,
  handleSelectLocation,
  handleSelectLocationBlur,
  handleClear,
  setRef,
  classNamePrefix,
  menuPortalTarget = false
}) {
  const [locationObject, setLocationObject] = useState(null)
  const { t } = useTranslation()
  // const inputRef = React.createRef()
  // useEffect(() => {
  //   if (setRef) {
  //     setRef(inputRef)
  //   }
  // }, [])

  useEffect(() => {
    if (value) {
      setLocationObject(value)
    }
  }, [value])

  const noOptionStyle = {
    textAlign: 'left'
  }

  const handleBlur = () => {
    handleSelectLocationBlur(locationObject)
  }

  const handleChange = (location, actionMeta) => {
    if (actionMeta && actionMeta.action === 'clear') {
      handleClear()
    } else {
      if (location && location.value) {
        geocodeByPlaceId(location.value.place_id)
          .then((results) => {
            const formattedLocation = formatGoogleResult(results[0])
            setLocationObject(formattedLocation)
            handleSelectLocation(formattedLocation)
          })
          .catch((error) => console.error(error))
      }
    }
  }
  return (
    <div className={`${styles.locationContainer} ${locationContainerCSS}`}>
      <GooglePlacesAutocompleteExtended
        minLengthAutocomplete={appConstantSettings.GOOGLE_AUTOCOMPLETE_MIN_LENGTH}
        apiKey={config.googleFrontKey}
        apiOptions={{ language: 'en' }}
        debounce={500}
        onLoadFailed={(error) => console.error('Could not inject Google script', error)}
        selectProps={{
          ...(menuPortalTarget ? { menuPortalTarget: document.querySelector('body') } : {}),
          onChange: handleChange,
          onBlur: handleBlur,
          // ref: { inputRef },
          noOptionsMessage: () =>
            t('global.locationWarning', { count: appConstantSettings.GOOGLE_AUTOCOMPLETE_MIN_LENGTH }),
          styles: { noOptionsMessage: (base) => ({ ...base, ...noOptionStyle }) },
          className: `${styles.googleSelect}`,
          classNamePrefix: classNamePrefix || '',
          placeholder: placeholder || t('global.locationPlaceholder'),
          isClearable: true,
          components: { DropdownIndicator: () => null, IndicatorSeparator: () => null },
          'aria-label': ariaLabel,
          value: locationObject &&
            locationObject.value && {
              label:
                locationObject.value.formatted_address ||
                `${locationObject.value.locality}, ${locationObject.value.country}`,
              value: locationObject.value.google_place_id,
              place_id: locationObject.value.google_place_id
            }
        }}
        autocompletionRequest={{
          types: []
        }}
        withSessionToken
        required
      />
    </div>
  )
}
